module.exports = __webpack_public_path__ + "assets/img/c22a3ee334ebdc3e890ce9194eae0aa1.png";